import React from 'react';
import { IconConnectorCcsType1 } from '../../../assets/icons/icon-connector-ccs-type1';
import { IconConnectorCcsType2 } from '../../../assets/icons/icon-connector-ccs-type2';
import { IconConnectorChademo } from '../../../assets/icons/icon-connector-chademo';
import { IconConnectorGbtAc } from '../../../assets/icons/icon-connector-gbt-ac';
import { IconConnectorGbtDc } from '../../../assets/icons/icon-connector-gbt-dc';
import { IconConnectorNACS } from '../../../assets/icons/icon-connector-nacs';
import { IconConnectorSchuko } from '../../../assets/icons/icon-connector-schuko';
import { IconConnectorType1 } from '../../../assets/icons/icon-connector-type1';
import { IconConnectorType2Plug } from '../../../assets/icons/icon-connector-type2-plug';
import { IconConnectorType2Socket } from '../../../assets/icons/icon-connector-type2-socket';
import { ReactNode } from 'react';

interface IConnectorsTypes {
    [k: string]: {
        name: string;
        icon: ReactNode;
    };
}

export enum EConnectorType {
    SCHUKO = 'schuko',
    TYPE1 = 'type1',
    J1772 = 'j1772',
    TYPE2_PLUG = 'type2-plug',
    TYPE2_SOCKET = 'type2-socket',
    CHADEMO = 'chademo',
    CCS_TYPE1 = 'ccs-type1',
    CCS_TYPE2 = 'ccs-type2',
    GBT_AC = 'gbt-ac',
    GBT_DC = 'gbt-dc',
    NACS = 'nacs',
}

export const normalizeConnectorType = (type?: string | null): string =>
    (type ?? '').trim().toLowerCase();

export const getConnectorTypes = (size: number = 46): IConnectorsTypes => ({
    [EConnectorType.SCHUKO]: {
        name: 'Schuko',
        icon: <IconConnectorSchuko size={size} />,
    },
    [EConnectorType.TYPE1]: {
        name: 'Type 1',
        icon: <IconConnectorType1 size={size} />,
    },
    [EConnectorType.J1772]: {
        name: 'Type 1',
        icon: <IconConnectorType1 size={size} />,
    },
    [EConnectorType.TYPE2_PLUG]: {
        name: 'Type 2',
        icon: <IconConnectorType2Plug size={size} />,
    },
    [EConnectorType.TYPE2_SOCKET]: {
        name: 'Type 2',
        icon: <IconConnectorType2Socket size={size} />,
    },
    [EConnectorType.CHADEMO]: {
        name: 'Chademo',
        icon: <IconConnectorChademo size={size} />,
    },
    [EConnectorType.CCS_TYPE1]: {
        name: 'CCS 1',
        icon: <IconConnectorCcsType1 size={size} />,
    },
    [EConnectorType.CCS_TYPE2]: {
        name: 'CCS 2',
        icon: <IconConnectorCcsType2 size={size} />,
    },
    [EConnectorType.GBT_AC]: {
        name: 'GB/T AC',
        icon: <IconConnectorGbtAc size={size} />,
    },
    [EConnectorType.GBT_DC]: {
        name: 'GB/T DC',
        icon: <IconConnectorGbtDc size={size} />,
    },
    [EConnectorType.NACS]: {
        name: 'NACS',
        icon: <IconConnectorNACS size={size} />,
    },
    default: {
        name: 'type1',
        icon: <IconConnectorType1 size={size} />,
    },
});
